import './App.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import routesConfig from './routes';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import useToken from './components/helpers/useToken';
import apiClient from './components/utils/apiClient';

const router = createBrowserRouter(routesConfig);
export const UserContext = React.createContext(null);


const App = () => {
  const [token, setToken] = useToken();
  const [notificationsStatus, setNotificationsStatus] = useState(false);
  const { t, i18n } = useTranslation();
  const [fields, setFields] = useState(null);
  const [mainFieldsOptions, setMainFieldsOptions] = useState([]);
  document.body.dir = i18n.dir();

  const getFields = async () => {
    try {
        const response = await apiClient.get(`/fields`);
        if(response?.data) {
          setFields(response?.data);
          setMainFieldsOptions(response?.data?.map(field => ({value: field?.field?.code, label: field?.field?.name?.ar})));
        }
      } catch(err) {}
  }


  const getNotificationsStatus = async () => {
    try {
        const response = await apiClient.get(`/b-notifications`);
        if(response?.data) {
          setNotificationsStatus(response?.data?.filter(notification => notification?.isRead === false)?.length > 0);
        }
      } catch(err) {}
  }

  useEffect(()=>{
    if(token) {
      getFields();
      getNotificationsStatus();
    }
  },[token])



  return <UserContext.Provider value={{ 
    fields: fields,
    mainFieldsOptions: mainFieldsOptions,
    notificationsStatus: notificationsStatus,
    setNotificationsStatus: setNotificationsStatus  }}><RouterProvider router={router} /></UserContext.Provider>;
};

export default App;
